/* eslint-disable jsx-a11y/no-access-key */
/**
 * PageHeader
 * @module components/PageHeader
 */

import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { LocalizationContext } from 'context/localization.context';

import logotype from './logotype.svg';
import logotypelg from './logotype_white_bluebg.svg';
import {
	Heading,
	Header,
	LogoLink,
	LogoImg,
	TopBar,
	LeftWrapper,
	RightWrapper,
	MenuWrapper,
	LinkItem,
	MobileMegaMenuWrapper,
	MobileMenuOptionsWrapper,
	HeaderLayout,
	MegaMenuLayout,
	TickerWrapperDesktop,
	TickerWrapperMobile,
} from './PageHeader.styles';
import QuickSearch from 'components/ui/QuickSearch';
import MenuOptions from 'components/framework/MenuOptions';
import { MegaMenu } from 'components/common/MegaMenu';
import Cart from 'components/ui/Cart';
import MobilMenu from 'components/framework/MobileMenu';
import MobileMegaMenu from 'components/common/MobileMegaMenu';

import MyPagesMenuDropdown from 'components/ui/MyPagesMenuDropdown';
import LanguageSelector from '../LanguageSelector';
import LanguageSelectorOld from 'components/framework/LanguageSelector/LanguageSelectorOld';
import AnnouncementBar from '../AnnouncementBar';
import Ticker from '../Ticker';
import { useSelector } from 'react-redux';
import { selectCartObject } from 'store/modules/cart';
import { toast } from 'react-toastify';
import { useSiteType } from 'context/siteType.context';
import useWindowSize from 'hooks/useWindowSize';
import { ViewContext } from 'context/view.context';
import Icon from 'components/ui/Icon';

const PageHeader = ({ header, api, includeHeading, modelType }) => {
	const { t } = useContext(LocalizationContext);
	const { view } = useContext(ViewContext);
	const siteType = useSiteType();
	const isLindabGroup = siteType === 'LindabGroup';
	const {
		cartStatus,
		errorList,
		cartDisabled,
		cartHidden,
		cartLink,
	} = useSelector(selectCartObject);
	const [mobileMenuExpanded, setMobileMenuExpanded] = useState(false);
	const isMobile = useWindowSize(1150);
	const isSmallMobile = useWindowSize(768);

	useEffect(() => {
		if (cartStatus === 'invalid' && errorList && errorList?.length > 0) {
			errorList?.forEach((error) => {
				const errormsg = `Error ${error.errorCode} - ${error.message}`;
				toast(errormsg, {
					type: toast.TYPE.ERROR,
				});
			});
		}
		//eslint-disable-next-line
	}, [cartStatus]);

	const {
		search,
		logo,
		megaMenu,
		myPagesLink,
		loginLink,
		logoutLink,
		warehouseTooltip,
		announcements,
		ticker,
	} = header;
	return (
		<>
			{announcements &&
				announcements.length > 0 &&
				announcements.map((item, index) => {
					return (
						<AnnouncementBar
							color={item.color}
							heading={item.heading}
							text={item.text}
							buttonText={item.button && item.button.text}
							url={item.button && item.button.link}
							id={item.id}
							key={index}
						/>
					);
				})}
			<Header isLindabGroup={isLindabGroup}>
				<a
					href="#main-content"
					accessKey="s"
					className="is-visuallyhidden focusable"
				>
					{t('shared/header/jumptomaincontent')}
				</a>

				<HeaderLayout backgroundColor={isLindabGroup ? 'lgDarkBlue' : 'beige'}>
					<TopBar isLindabGroup={isLindabGroup}>
						<LeftWrapper>
							<LogoLink
								as={logo && logo.link ? 'a' : 'div'}
								href={logo.link}
								title={logo && logo.link && t('shared/header/gotostartpage')}
							>
								<LogoImg
									src={
										header.logoSrc ?? (isLindabGroup ? logotypelg : logotype)
									}
									alt={header.logoAlt ?? logo.alt ? logo.alt : ''}
									isLindabGroup={isLindabGroup}
								/>
								{includeHeading && <Heading>Lindab</Heading>}
							</LogoLink>
							{siteType === 'Lindab' &&
								!cartDisabled &&
								(isMobile || view === 'mobile') &&
								view !== 'desktop' && (
									<div className="absolute top-0 right-0 mr-12 md:mr-20 md:mt-8">
										<Cart
											link={cartLink && cartLink.link}
											target={cartLink && cartLink.target}
											cartDisabled={cartDisabled}
										/>
									</div>
								)}
							{(isMobile || view === 'mobile') && view !== 'desktop' && (
								<div className="absolute top-0 right-0 -mt-1 md:mr-4 md:mt-8">
									<MobilMenu onChange={setMobileMenuExpanded} />
								</div>
							)}
							{search && (
								<QuickSearch
									searchLink={search.searchLink}
									quickSearchLink={search.quickSearchLink}
									searchPlaceholder={search.searchPlaceholder}
									activeMarket={header.activeMarket}
									api={api}
									shoppingCartUrl={(cartLink && cartLink.link) || ''}
									id="query"
									name="query"
								/>
							)}
							{megaMenu && megaMenu.items && megaMenu.items.length > 0 && (
								<MobileMegaMenuWrapper
									style={{
										display:
											(isMobile || view === 'mobile') && view !== 'desktop'
												? 'block'
												: 'none',
									}}
									expanded={mobileMenuExpanded}
								>
									<MobileMegaMenu
										items={megaMenu}
										loginLink={loginLink}
										logoutLink={logoutLink}
										myPagesLink={myPagesLink}
										expanded={
											mobileMenuExpanded &&
											(isMobile || view === 'mobile') &&
											view !== 'desktop'
										}
									/>

									{((siteType === 'Lindab' && cartDisabled) ||
										isLindabGroup) && (
										<>
											{header.languageSelector &&
												header.languageSelector.languages && (
													<LanguageSelector
														preamble={header.languageSelector.preamble}
														modalHeading={header.languageSelector.modalHeading}
														heading={header.languageSelector.heading}
														languages={header.languageSelector.languages}
														mobile={true}
													/>
												)}
											{!header.languageSelector && header?.languages && (
												<LanguageSelectorOld
													languages={header.languages}
													mobile={true}
												/>
											)}
										</>
									)}
									{siteType === 'Lindab' && !cartDisabled && (
										<MobileMenuOptionsWrapper>
											<MenuOptions warehouseTooltip={warehouseTooltip} />
										</MobileMenuOptionsWrapper>
									)}
								</MobileMegaMenuWrapper>
							)}
						</LeftWrapper>
						{isLindabGroup && ticker && (
							<TickerWrapperDesktop>
								<Ticker
									date={ticker.date}
									price={ticker.price}
									tradeCurrency={ticker.tradeCurrency}
									delta={ticker.delta}
								/>
							</TickerWrapperDesktop>
						)}

						<RightWrapper
							style={{
								display:
									(isMobile || view === 'mobile') && view !== 'desktop'
										? 'none'
										: 'flex',
							}}
						>
							{isLindabGroup &&
								header.languageSelector &&
								header.languageSelector.languages && (
									<LanguageSelector
										preamble={header.languageSelector.preamble}
										modalHeading={header.languageSelector.modalHeading}
										heading={header.languageSelector.heading}
										languages={header.languageSelector.languages}
									/>
								)}

							{isLindabGroup &&
								!header.languageSelector &&
								header?.languages && (
									<LanguageSelectorOld languages={header.languages} />
								)}

							{siteType === 'Lindab' &&
								cartDisabled &&
								header &&
								header.languageSelector &&
								header.languageSelector.languages && (
									<LanguageSelector
										preamble={header.languageSelector.preamble}
										modalHeading={header.languageSelector.modalHeading}
										heading={header.languageSelector.heading}
										languages={header.languageSelector.languages}
									/>
								)}
							{siteType === 'Lindab' &&
								cartDisabled &&
								!header.languageSelector &&
								header?.languages && (
									<LanguageSelectorOld languages={header.languages} />
								)}
							{siteType === 'Lindab' && !cartDisabled && (
								<MenuOptions warehouseTooltip={warehouseTooltip} />
							)}
						</RightWrapper>
					</TopBar>
					{isLindabGroup && ticker && (
						<TickerWrapperMobile>
							<Ticker
								date={ticker.date}
								price={ticker.price}
								tradeCurrency={ticker.tradeCurrency}
								delta={ticker.delta}
							/>
						</TickerWrapperMobile>
					)}
				</HeaderLayout>

				<MegaMenuLayout
					style={{
						display:
							(isMobile || view === 'mobile') && view !== 'desktop'
								? 'none'
								: 'block',
					}}
					isLindabGroup={isLindabGroup}
					isStartPage={modelType === 'StartPage'}
				>
					<MenuWrapper
						style={{
							display:
								(isMobile || view === 'mobile') && view !== 'desktop'
									? 'none'
									: 'flex',
						}}
					>
						<MegaMenu menuItems={megaMenu.items} />
						{siteType === 'Lindab' && (
							<div className="flex items-center">
								{cartDisabled ? (
									<>
										{loginLink && loginLink.link && (
											<LinkItem
												href={loginLink && loginLink.link}
												target={loginLink && loginLink.target}
											>
												<Icon
													icon="login"
													color="black"
													size={1}
													className="mr-2"
												/>
												<span>{t('shared/header/login')}</span>
											</LinkItem>
										)}
									</>
								) : (
									<>
										{myPagesLink && (
											<MyPagesMenuDropdown
												myPagesLink={myPagesLink}
												logoutLink={logoutLink}
											/>
										)}
									</>
								)}
								{!cartHidden && (
									<Cart
										link={cartLink && cartLink.link}
										target={cartLink && cartLink.target}
										cartDisabled={cartDisabled}
									/>
								)}
							</div>
						)}
					</MenuWrapper>
				</MegaMenuLayout>
			</Header>
		</>
	);
};

PageHeader.propTypes = {
	header: PropTypes.shape({
		search: PropTypes.shape({
			searchLink: PropTypes.string,
			searchPlaceholder: PropTypes.string,
			ajaxSearchLink: PropTypes.string,
			autoCompleteLink: PropTypes.string,
		}),
		logo: PropTypes.shape({
			link: PropTypes.string,
			alt: PropTypes.string,
		}),
		logoSrc: PropTypes.string,
		logoAlt: PropTypes.string,
		markets: PropTypes.arrayOf(
			PropTypes.shape({
				link: PropTypes.string,
				text: PropTypes.string,
				active: PropTypes.bool,
			})
		),
		customers: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string,
				id: PropTypes.string,
			})
		),
		projects: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string,
				id: PropTypes.string,
			})
		),
		warehouses: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string,
				id: PropTypes.string,
			})
		),
		megaMenu: PropTypes.shape({
			items: PropTypes.arrayOf(
				PropTypes.shape({
					link: PropTypes.string,
					text: PropTypes.string,
					active: PropTypes.bool,
					children: PropTypes.array,
				})
			),
		}),
		loginLink: PropTypes.shape({
			link: PropTypes.string,
			target: PropTypes.string,
		}),
		logoutLink: PropTypes.string,
		myPagesLink: PropTypes.objectOf(
			PropTypes.shape({
				link: PropTypes.string,
				text: PropTypes.string,
				active: PropTypes.bool,
				children: PropTypes.array,
			})
		),
		cart: PropTypes.shape({
			items: PropTypes.number,
		}),
	}),
	api: PropTypes.shape({
		projectsUrl: PropTypes.string,
	}),
	includeHeading: PropTypes.bool,
	modelType: PropTypes.string,
};

export default PageHeader;
